import { Tabs } from '@mantine/core'
import { FunctionComponent } from 'react'
import { useAuthenticatedUser } from '~/auth/user.hooks'
import { useScopePermissions } from '~/auth/useScopePermissions'
import { LegacyApiKeysTab } from './LegacyApiKeysTab'
import { ServiceApiKeysTab } from './ServiceApiKeysTab'

export const SettingsApiKeys: FunctionComponent = () => {
  const { isOwner } = useScopePermissions()
  const user = useAuthenticatedUser()

  // The service keys tab is for owners of scopes with the serviceApiKeys feature: the backend answers 403 to anyone else.
  if (!isOwner || !user.hasFeature('serviceApiKeys')) return <LegacyApiKeysTab />

  return (
    <Tabs defaultValue="legacy" keepMounted={false} classNames={{ root: 'flex flex-col gap-4' }}>
      <Tabs.List>
        <Tabs.Tab value="legacy">Legacy keys</Tabs.Tab>
        <Tabs.Tab value="service">Service keys</Tabs.Tab>
      </Tabs.List>
      <Tabs.Panel value="legacy">
        <LegacyApiKeysTab />
      </Tabs.Panel>
      <Tabs.Panel value="service">
        <ServiceApiKeysTab />
      </Tabs.Panel>
    </Tabs>
  )
}
